// Plugin for Vertical Line on Tooltip Hover
export const tooltipLinePlugin = { 
    id: 'tooltipLine',
    afterDatasetsDraw: (chart) => { 
        const { ctx, chartArea, tooltip } = chart;
        if (!chartArea || !tooltip?.getActiveElements()?.length) return;
        const { top, bottom } = chartArea;
        const activeElement = tooltip.getActiveElements()[0];
        const xCoord = activeElement.element.x; 
        const pluginOptions = chart.options.plugins.tooltipLine || {};
        const lineColor = pluginOptions.lineColor || 'rgba(128, 128, 128, 0.6)';
        const lineWidth = pluginOptions.lineWidth || 1; 
        ctx.save();
        ctx.beginPath();
        ctx.moveTo(xCoord, top);
        ctx.lineTo(xCoord, bottom);
        ctx.lineWidth = lineWidth;
        ctx.strokeStyle = lineColor;
        ctx.stroke(); 
        ctx.restore();
    } 
};

 // Plugin for Vertical "Today" Line
 export const verticalLinePlugin = {
    id: 'todayLine',
    afterDatasetsDraw: (chart) => {
     const { ctx, chartArea, scales, data } = chart;
     if (!chartArea || !scales || !scales.x || !data || !data.labels) return;
     const { top, bottom, left, right } = chartArea;
     const { x } = scales;
     const pluginOptions = chart.options.plugins.todayLine || {};
     const todayDataIndex = pluginOptions.todayDataIndex;
     const shortermEndDayIndex = pluginOptions.shortermEndDayIndex;
   
  
    //  const lineTopOffset = pluginOptions.lineTopOffset || 10; // Default offset
   
  
     const drawLine = (index, color, dash, topOffset) => {
      if (typeof index !== 'number' || index < 0 || index >= data.labels.length || index < 0) return;
      const labelForIndex = data.labels[index];
      const xCoord = x.getPixelForValue(labelForIndex, index);
      if (typeof xCoord !== 'number' || xCoord < left || xCoord > right) return;
      ctx.save();
      ctx.beginPath();
      ctx.moveTo(xCoord, top + topOffset); // Apply offset here
      ctx.lineTo(xCoord, bottom);
      ctx.lineWidth = pluginOptions.lineWidth || 1;
      ctx.strokeStyle = color;
      if (dash && Array.isArray(dash)) ctx.setLineDash(dash);
      ctx.stroke();
      ctx.setLineDash([]);
      ctx.restore();
     };
   
  
     const drawLabel = (index, text, xOffset, yOffset, labelFontColor) => {
      if (typeof index !== 'number' || index < 0 || index >= data.labels.length || index < 0) return;
      const labelForIndex = data.labels[index];
      const xCoord = x.getPixelForValue(labelForIndex, index);
      if (typeof xCoord !== 'number' || xCoord < left || xCoord > right) return;
      ctx.save();
      ctx.font = `${pluginOptions.labelFontSize || 10}px ${pluginOptions.labelFontColor || 'Saira'}`;
      ctx.fillStyle = labelFontColor;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'bottom';
      ctx.fillText(text, xCoord + xOffset, top - (pluginOptions.labelOffset || 8) - yOffset);
      ctx.restore();
     };
   
  
     // Draw "today" line
     if (typeof todayDataIndex === 'number' && todayDataIndex >= 0) {
      drawLine(todayDataIndex, pluginOptions.lineColor || 'rgba(0, 0, 0, 0.6)', pluginOptions.lineDash, pluginOptions.lineTopOffset || 15);
      drawLabel(todayDataIndex, '', 0, 0);
     }
   
  
     // Draw 16-day line
     if (typeof shortermEndDayIndex === 'number' && shortermEndDayIndex >= 0) {
      drawLine(shortermEndDayIndex, 'rgba(0, 0, 0, 0.9)', pluginOptions.line, 0);
      drawLabel(shortermEndDayIndex, 'Short Term', -35, -20, 'rgba(0, 0, 0, 0.9)');
      drawLabel(shortermEndDayIndex, 'Seasonal', 33, -20, 'rgba(0, 0, 0, 0.9)');
     }
    }
   };